<template>
  <div class="modal fade" ref="modal" id="creditoModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-navy">
          <h4 class="modal-title">
            <i class="fas fa-hand-holding-usd mr-2"></i>
            {{ isEdit ? 'Gestionar Línea de Crédito' : 'Apertura de Crédito' }}
          </h4>
          <button type="button" class="close text-white" data-dismiss="modal" @click="close">&times;</button>
        </div>

        <div class="modal-body">
          <div v-if="clienteEsInactivo" class="alert alert-warning">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            <strong>Atención:</strong> Este cliente se encuentra INACTIVO. El controlador bloqueará cualquier modificación financiera.
          </div>

          <div class="row">
            <div class="col-md-12 border-bottom mb-3 pb-2">
              <div class="form-group row" v-if="!isEdit">
                <label class="col-sm-3 col-form-label font-weight-bold">Asignar a Cliente:</label>
                <div class="col-sm-9">
                  <select ref="selectCliente" class="form-control select2" v-model="selectedCliente">
                    <option value="">Buscar cliente sin crédito...</option>
                    <option v-for="cliente in clientesSinCredito.filter(c => c.estatus !== 0)" :key="cliente.id" :value="cliente.id">
                      {{ cliente.codigo }} - {{ cliente.nombre }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-else class="form-group row">
                <label class="col-sm-3 col-form-label font-weight-bold">Titular de Cuenta:</label>
                <div class="col-sm-9">
                  <div class="p-2 bg-light border rounded">
                    <strong>{{ creditData.cliente?.codigo }}</strong> - {{ creditData.cliente?.nombre }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 border-right">
              <h6 class="text-primary font-weight-bold mb-3"><i class="fas fa-cog"></i> Configuración</h6>
              
              <div class="form-group">
                <label>Límite de Crédito ($)</label>
                <inputComponent v-model="form.limite" />
                <small class="text-muted">Monto máximo que el cliente puede adeudar.</small>
              </div>

              <div class="form-group">
                <label>Días de Plazo</label>
                <input type="number" class="form-control" v-model.number="form.dias_credito" 
                  :max="maximo" @input="checkMaxValue" :class="{ 'is-invalid': showWarning }">
                <div v-if="showWarning" class="invalid-feedback">
                  El límite establecido por política es de {{ maximo }} días.
                </div>
              </div>

              <div class="form-group">
                <label>Límite de Ventas</label>
                <input type="number" class="form-control" v-model.number="form.limite_ventas" min="1">
                <small class="text-muted">Cantidad máxima de facturas pendientes permitidas.</small>
              </div>

              <div class="form-group">
                <label>Estatus de Línea</label>
                <select class="form-control" v-model="form.estatus" :class="estatusClass">
                  <option value="activo">ACTIVO (Permite ventas)</option>
                  <option value="bloqueado">BLOQUEADO (Suspensión manual)</option>
                  <option value="vencido">VENCIDO (Por mora)</option>
                </select>
              </div>
            </div>

            <div class="col-md-6 bg-light p-3 rounded">
              <h6 class="text-navy font-weight-bold mb-3"><i class="fas fa-balance-scale"></i> Estado de Cuenta</h6>
              
              <div class="form-group">
                <label>Deuda Actual ($)</label>
                <inputComponent v-model="form.deuda" :disabled="isEdit" />
                <small v-if="isEdit" class="text-info">Actualizado automáticamente vía Ventas.</small>
                <small v-else class="text-orange">Generará un asiento de ajuste automático.</small>
              </div>

              <div class="form-group">
                <label>Total Abonado ($)</label>
                <inputComponent v-model="form.abonado" :disabled="true" />
                <small class="text-info">Actualizado automáticamente vía Pagos.</small>
              </div>

              <hr>
              <div class="text-center">
                <label class="mb-0">SALDO PENDIENTE</label>
                <h3 :class="saldoCalculado > 0 ? 'text-danger' : 'text-success'">
                  {{ saldoCalculado.toFixed(2) }} $
                </h3>
              </div>

              <hr v-if="isEdit">
              <div v-if="isEdit && !showAjusteForm" class="text-center">
                <button type="button" class="btn btn-outline-warning btn-sm" @click="showAjusteForm = true">
                  <i class="fas fa-edit mr-1"></i> ¿Corregir Saldo Inicial?
                </button>
              </div>

              <div v-if="showAjusteForm" class="card card-warning card-outline mt-3">
                <div class="card-body p-2">
                  <h6 class="font-weight-bold text-dark"><i class="fas fa-exclamation-circle"></i> Nueva Corrección</h6>
                  <div class="form-group mb-2">
                    <label class="small">Monto del Nuevo Ajuste ($)</label>
                    <inputComponent v-model="ajusteForm.monto" />
                  </div>
                  <div class="form-group mb-2">
                    <label class="small">Motivo de la corrección</label>
                    <textarea class="form-control form-control-sm" v-model="ajusteForm.motivo" rows="2" 
                      placeholder="Ej: Error en carga inicial, se anula factura anterior..."></textarea>
                  </div>
                  <div class="d-flex justify-content-between">
                    <button type="button" class="btn btn-default btn-xs" @click="cancelarAjuste">Cancelar</button>
                    <button type="button" class="btn btn-warning btn-xs font-weight-bold" @click="procesarAjusteManual">
                      Aplicar Ajuste
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer justify-content-between bg-light">
          <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="close">
            <i class="fas fa-times mr-1"></i> Cancelar
          </button>
          
          <div>
            <button type="button" class="btn btn-outline-info mr-2" @click="limpiarCampos" v-if="!isEdit">
              <i class="fas fa-eraser mr-1"></i> Limpiar
            </button>
            <button type="button" class="btn btn-success px-4 shadow" @click="guardar" :disabled="clienteEsInactivo">
              <i class="fas fa-save mr-1"></i> {{ isEdit ? 'Actualizar Línea' : 'Aperturar Crédito' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { Modal } from "bootstrap";
import InputComponent from "./InputComponent.vue";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';

export default {
  components: { InputComponent },
  props: {
    creditData: { type: Object, default: null }
  },
  data() {
    return {
      form: this.getDefaultForm(),
      maximo: 90,
      showWarning: false,
      selectedCliente: "",
      clientesSinCredito: [],
      showAjusteForm: false,
      ajusteForm: {
        monto: 0,
        motivo: ""
      }
    };
  },
  computed: {
    isEdit() { return !!(this.creditData && this.creditData.id); },
    saldoCalculado() { return parseFloat(this.form.deuda || 0) - parseFloat(this.form.abonado || 0); },
    clienteEsInactivo() { return this.isEdit && this.creditData.cliente?.estatus === 0; },
    estatusClass() {
      return {
        'text-success border-success': this.form.estatus === 'activo',
        'text-danger border-danger': this.form.estatus === 'bloqueado',
        'text-warning border-warning': this.form.estatus === 'vencido'
      };
    }
  },
  watch: {
    creditData: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form = { ...val };
          this.selectedCliente = val.cliente_id;
        } else {
          this.limpiarCampos();
        }
      }
    }
  },
  methods: {
    getDefaultForm() {
      return {
        limite: 0, deuda: 0, abonado: 0, limite_ventas: 1,
        dias_credito: 7, fecha_vencimiento: '', estatus: 'activo'
      };
    },
    async cargarClientesSinCredito() {
      try {
        const { data } = await api.get("/clientes-sin-credito");
        this.clientesSinCredito = data;
        this.inicializarSelect2();
      } catch (e) { console.error(e); }
    },
    inicializarSelect2() {
      this.$nextTick(() => {
        const select = $(this.$refs.selectCliente);
        select.select2({ theme: "bootstrap4", placeholder: "Buscar cliente..." })
              .on("change", () => { this.selectedCliente = select.val(); });
      });
    },
    checkMaxValue() { this.showWarning = this.form.dias_credito > this.maximo; },
    cancelarAjuste() {
      this.showAjusteForm = false;
      this.ajusteForm = { monto: 0, motivo: "" };
    },
    async procesarAjusteManual() {
      if (this.ajusteForm.monto <= 0) return alert.toast({ title: 'El monto debe ser mayor a 0', icon: 'warning' });
      if (this.ajusteForm.motivo.length < 10) return alert.toast({ title: 'Indique un motivo más detallado', icon: 'warning' });

      try {
        loading.show('Verificando ajustes previos...');
        
        const payload = {
          cliente_id: this.selectedCliente,
          monto: this.ajusteForm.monto,
          motivo: this.ajusteForm.motivo
        };

        await api.post("/creditos/ajuste-manual", payload);

        loading.hide();
        alert.toast({ title: 'Ajuste aplicado correctamente', icon: 'success' });
        
        this.cancelarAjuste();
        this.$emit("saved");
        window.$("#creditoModal").modal("hide");
      } catch (error) {
        loading.hide();
        this.manejarError(error);
      }
    },
    async guardar() {
      if (!this.selectedCliente) return alert.toast({ title: 'Seleccione un cliente', icon: 'warning' });
      
      try {
        loading.show('Procesando ajuste financiero...');
        const payload = { ...this.form, cliente_id: this.selectedCliente };
        if (this.isEdit) {
          await api.put(`/credito/${this.creditData.id}`, payload);
        } else {
          await api.post("/credito", payload);
        }

        loading.hide();
        alert.toast({ title: '¡Crédito actualizado con éxito!', icon: 'success' });
        this.$emit("saved");
        window.$("#creditoModal").modal("hide");
      } catch (error) {
        loading.hide();
        this.manejarError(error);
      }
    },
    manejarError(error) {
      const data = error.response?.data;
      alert.toast({ 
        title: data?.message || 'Error financiero', 
        text: data?.detalles || 'No se pudo procesar la solicitud.',
        icon: 'error',
        timer: 6000 
      });
    },
    limpiarCampos() { 
      this.form = this.getDefaultForm(); 
      this.selectedCliente = "";
      $(this.$refs.selectCliente).val("").trigger("change");
    },
    close() { this.$emit('cancelled'); }
  },
  mounted() {
    this.cargarClientesSinCredito();
  }
};
</script>